function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 495 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.44,
    cy: 94.347,
    rx: 90.91,
    ry: 85.939,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "9.96px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.408,
    y: 378.374,
    width: 113.828,
    height: 25.599,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "9.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.779,223.276c-25.127,-5.052 -51.664,-5.878 -77.339,-6.055c-60.276,-0.24 -119.701,13.701 -173.033,40.593c-4.837,2.402 -7.869,7.217 -7.831,12.433l0,102.579l135.792,-0l-0,111.355c-0,10.031 8.621,18.285 19.098,18.285l308.825,-0c10.477,-0 19.099,-8.254 19.099,-18.285l-0,-189.066c-0,-10.031 -8.622,-18.285 -19.099,-18.285l-131.207,0l-0,-18.285c-0,-10.031 -8.622,-18.285 -19.099,-18.285c-10.477,0 -19.099,8.254 -19.099,18.285l0,18.285l-37.051,0m187.358,189.432l-270.628,-0l-0,-152.862l120.321,-0l0,16.639c0,10.031 8.622,18.285 19.099,18.285c10.477,0 19.099,-8.254 19.099,-18.285l-0,-16.639l112.109,-0l-0,152.862Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "9.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.702,217.221c0,0 -0.006,0 0.004,0c60.276,-0.24 119.701,13.701 173.033,40.593c4.837,2.402 7.869,7.217 7.831,12.433l0.397,8.849",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "9.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,407.439l0,-113.058c0,-9.852 8.355,-17.851 18.646,-17.851l137.242,-0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "9.96px",
      strokeLinecap: "round",
      strokeMiterlimit: 1.5
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeGroup);
export default __webpack_public_path__ + "static/media/employee-group.d91f3bf326ec760414720d9470b31eee.svg";
export { ForwardRef as ReactComponent };